module.exports = false;




//////////////////
// WEBPACK FOOTER
// ../contensis-core-api/node_modules/detect-node/browser.js
// module id = 7
// module chunks = 0